import React from 'react';
import Pill from '@/app/common/components/Pill/index.tsx';
import { PillHiddenLabel } from '@/app/common/components/Pill/styled.ts';
import { Badge } from '@/app/components/search/components/NoResults/BadgesContainer/styled.ts';
import { CloseIcon } from '@/app/components/search/components/NoResults/BadgesContainer/Badges.tsx';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation.tsx';

export type handleFilterClicked = () => void;

type FilterBadgeStandardProps = {
  label: string | React.ReactElement | React.ReactElement[];
  handleFilterClicked: handleFilterClicked;
  isLoading?: boolean;
};

export const FilterBadgeContent = ({ label, handleFilterClicked, isLoading }: FilterBadgeStandardProps) => {
  const { useEvoFilters } = useFiltersUiData();
  const { t } = useTranslation();

  if (!useEvoFilters)
    return (
      <Badge
        onClick={isLoading ? undefined : handleFilterClicked}
        aria-disabled={isLoading || undefined}
        key={`${label}`}
      >
        {label}
        &nbsp;
        <CloseIcon />
      </Badge>
    );

  return (
    <Pill
      label={
        // MPH-262: the chip removes its filter, so its name says so after the value ("£222 - £1,500 Clear"),
        // with the "Clear" copy the legacy filter bar already uses. Nothing changes visually.
        <>
          {Array.isArray(label) ? <span>{label}</span> : label}
          <PillHiddenLabel>{` ${t('vacation.oss.filters.clear')}`}</PillHiddenLabel>
        </>
      }
      selected={true}
      isLoading={false}
      busy={isLoading}
      isOpen={false}
      hasPopover={false}
      removes={true}
      handleClick={handleFilterClicked}
    />
  );
};
